import React, { useState, useMemo } from "react";
import { Waypoint } from "react-waypoint";
import innerHeight from "ios-inner-height";

import "./contact.css";

const LIGHT_LEVELS = [1, 2, 3, 4, 5, 6];

function StatusItem(props) {
  const [shelfsActive, setShelfsActive] = useState(false);
  const windowHeight = useMemo(() => innerHeight(), []);

  const isLightLevelActive = (level) => {
    return props.shelf?.[1]?.io?.lights?.[`level${level}`]?.value === "true" && shelfsActive;
  };

  return (
    <Waypoint
      onEnter={() => setShelfsActive(true)}
      onLeave={() => setShelfsActive(false)}
      topOffset={windowHeight * 0.25}
      bottomOffset={windowHeight * 0.25}
    >
      <div className="StatusInnerImgOuter">
        <img
          className="StatusInnerImg"
          src="https://firebasestorage.googleapis.com/v0/b/vert-farm-api.appspot.com/o/web%2Fimg%2Fstatus%2Flow.jpg?alt=media"
          alt="Shelf"
        />
        {shelfsActive && (
          <img
            className="StatusInnerImg"
            src="https://firebasestorage.googleapis.com/v0/b/vert-farm-api.appspot.com/o/web%2Fimg%2Fstatus%2Fmedium.jpeg?alt=media"
            alt="Shelf"
            style={{ opacity: props.shelfOpacity }}
          />
        )}

        {LIGHT_LEVELS.map((level) =>
          isLightLevelActive(level) ? (
            <img
              key={level}
              className="StatusInnerImg"
              src={`https://firebasestorage.googleapis.com/v0/b/vert-farm-api.appspot.com/o/web%2Fimg%2Fstatus%2Flevel${level}.png?alt=media`}
              alt="Shelf"
            />
          ) : null
        )}
      </div>
    </Waypoint>
  );
}

export default StatusItem;
